import React from "react";

function Bills() {
  return <div>I am bills</div>;
}

export default Bills;
